<template>
  <div class="main-container">
    <HeaderElement />

    <HeroBranding/>

    <GallerySearch />

    <div v-if="libaries && 0 < libaries.length" class="tabs-wrapper startup-tab section-space pt-5 section-space--pb_120 bg-gray">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title-wrapper text-center mb-4 wow move-up">
              <h1 class="section-title font-weight--bold mb-15 font-weight--light">
                <span class="top-libaries__headline-tag">Unsere</span>
                <span class="top-libaries__headline-main">Empfehlung</span>
              </h1>
            </div>
          </div>
        </div>
        <!-- top libaries -->
        <TopLibaries :libaries="libaries" />
      </div>
    </div>

    <!-- business analytics start -->
    <div class="faq-banner-area" id="offer">
      <FaqBanner />
    </div>

    <!-- requirement section-->
    <div class="requirements-area" id="clients">
      <RequireList/>
    </div>

    <!-- requirement section two-->
    <div class="requirements-area" id="merchants">
      <RequireListTwo/>
    </div>

    <!-- requirement section two-->
    <div class="requirements-area section-space--pb_120">
      <RequireListTree/>
    </div>

    <!-- fun facts section -->
    <div class="fun-fact-wrapper section-space--pb_120">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title text-center section-space--mb_60">
              <h2 class="font-weight--light mb-15 move-up">Unser Ziel ist es, jedem die Möglichkeit zu bieten  das Beste rauszuholen</h2>
            </div>
          </div>
        </div>
        <!-- fun fact component -->
        <FunFactOne />
      </div>
    </div>

    <!-- testimonials component -->
    <EbookTestimonial />
    <!-- testimonials component -->

    <!-- contact form section -->
    <div class="contact-form-area" id="contact">
      <div class="container">
        <!-- contact form component -->
        <ContactForm :mail="mail"/>
      </div>
    </div>

    <!-- footer section -->
    <FooterMain/>
      <OffCanvasMobileMenu />
  </div>
</template>

<script>
import HeaderElement from '@/components/HeaderElement'
import HeroBranding from '../components/HeroBranding'
import FaqBanner from "../components/FaqBanner"
import RequireList from '../components/RequireList'
import RequireListTwo from '../components/RequireListTwo'
import RequireListTree from '../components/RequireListTree' 
import FunFactOne from "../components/FunFactOne"
import EbookTestimonial from '@/components/sections/EbookTestimonial'
import ContactForm from '../components/ContactForm'
import FooterMain from '../components/FooterMain'
import TopLibaries from '../components/TopLibaries'
import { apiUrl } from '@/config.js'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'
import ScrollTo from '@/components/mixins/scrollTo.js'
import GallerySearch from '../components/GallerySearch.vue'

export default {
  name: 'app',
  components: {
    ContactForm,
    HeaderElement,
    HeroBranding,
    FaqBanner,
    RequireList,
    RequireListTwo,
    RequireListTree,
    FunFactOne,
    FooterMain,
    EbookTestimonial,
    OffCanvasMobileMenu,
    TopLibaries,
    GallerySearch
  },
  mixins: [ScrollTo],
  data() {
    return {
      libaries: null,
      mail: {
        subject: 'Zentralregister-Zugang',
      }
    }
  },
  mounted() {
    Promise.all([
      this.$axios.get(`${apiUrl}libaries`),
      setTimeout(() => this.prefillContact(), 1000)
    ]).then(results => {
      this.libaries = results[0].data.libaries
    })
  },
  methods: {
    prefillContact() {
      if ('access' === this.$route.query.fill) {
        this.scrollTo('contact')
        document.querySelector("input[name=con_subject]").value = 'Zentralregister-Zugang'
        document.querySelector("textarea[name=con_message]").value = 'Bitte um Kontaktaufnahme, um einen Zugang zum Zentralregister zu erhalten'
      }
      if (this.$route.query.product) {
        this.scrollTo('contact')
        document.querySelector("input[name=con_subject]").value = `Zugang zu MHP-Finance: ${this.$route.query.product}`
        document.querySelector("textarea[name=con_message]").value = `Bitte um Kontaktaufnahme für das Digital-Produkt: ${this.$route.query.product}.`
      }
    }
  }
}
</script>

<style lang="scss">
@use '../assets/scss/_variabls' as vars;

.top-libaries {
  &__headline {
    &-tag {
      background: vars.$theme-color--default;
      padding: 2px 10px 5px 10px;
      border-radius: 4px;
      font-size: 3.2rem;
      color: white;
      font-weight: 400;
      margin-right: 8px;
    }

    &-main {
      color: vars.$theme-color--default;
      font-weight: 400;
    }
  }

  &__sold {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .testimonial-slider {
      &__single {
        width: 100%;
        margin: 10px 0;
        padding: 0.2rem 0;
        border-radius: 5px;
        border: 5px solid vars.$theme-color--default;
      }

      &__text {
        margin-bottom: 0px;
      }
    }
  }
}

@media #{vars.$tablet-up} {
  .top-libaries {
    &__sold {
      flex-direction: row;

      .testimonial-slider {
        &__single {
          width: auto;
          min-width: 250px;
          margin: 0;
          padding: 5px 0;
        }
      }
    }
  }
}
</style>
